module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_activities02-32391c96bf050a159050de88b4b6aa11.jpg";